import {style} from '@vanilla-extract/css'

export const menuDivider = style({
  height: '1px',
  border: 0,
  background: 'var(--card-hairline-soft-color)',
  margin: 0,
})
